/** A page number, or a gap where numbers were left out. */
export type PageSlot = number | 'gap';

/**
 * Which page numbers a pager shows: all of them up to `max`, otherwise the first, the last,
 * the current with one neighbour each side, and a gap for the rest. The window never shrinks
 * below `max` slots near the edges, so the pager keeps its width while the person pages.
 */
export function pageWindow(current: number, total: number, max = 7): PageSlot[] {
    if (total <= max) return Array.from({ length: total }, (_, i) => i + 1);
    const inner = max - 2;
    if (current <= inner - 1) {
        return [...Array.from({ length: inner }, (_, i) => i + 1), 'gap', total];
    }
    if (current >= total - (inner - 2)) {
        return [1, 'gap', ...Array.from({ length: inner }, (_, i) => total - inner + 1 + i)];
    }
    const side = Math.floor((inner - 2) / 2);
    const middle = Array.from({ length: inner - 2 }, (_, i) => current - side + i);
    return [1, 'gap', ...middle, 'gap', total];
}
